import script from "./TheNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./TheNotifications.vue?vue&type=style&index=0&id=2056b258&lang=scss"

const __exports__ = script;

export default __exports__